import {PermissionHelperModule} from '../core/PermissionHelperModule';

export class PermissionsData {
    static permission =
        {
            roles: 'role_list',
            role: {
                add: 'role_add',
                update: 'role_update',
                view: 'role_view',
            },
            users: 'user_list',
            user: {
                add: 'user_add',
                update: 'user_update',
                view: 'user_view',
            },
            alerts: 'alert_list',
            devices: 'device_list',
            masking: 'masking_view',
            'device-events': 'device_event_list',
            'device-event':{
                add:'device_event_add',
            },
            device: {
                add: 'device_add',
                update: 'device_update',
                view: 'device_view',
            },
            'all-assets': 'asset_list',
            asset: {
                add: 'asset_add',
                update: 'asset_update',
                view: 'asset_view',
                'reporting-configuration': 'asset_update_reporting_configuration',
            },
            trips: 'trip_list',
            trip: {
                add: 'trip_add',
                update: 'trip_update',
                view: 'trip_view',
                'trip-type-a': 'trip_type_a_add',
                'trip-type-b': 'trip_type_b_add',
                'trip-type-c': 'trip_type_a_add',
                'trip-type-d': 'trip_type_d_add'
            },
            'asset-groups': 'asset_group_list',
            'asset-group': {
                add: 'asset_group_add',
                update: 'asset_group_update',
                view: 'asset_group_view',
            },
            drivers: 'drivers_list',
            driver: {
                add: 'drivers_add',
                update: 'drivers_update',
                view: 'drivers_view',
            },
            poi: {
                index: 'poi_list',
                add: 'poi_add',
                view: 'poi_update',
                update: 'poi_update'
            },
            zone: {
                index: 'zone_list',
                add: 'zone_add',
                update: 'zone_update',
                view: 'zone_view'
            },
            routes: 'routes_list',
            route: {
                add: 'routes_add',
                view: 'routes_view',
                update: 'routes_update'
            },
            'mapping-keys': 'mapping_key_list',
            events: 'events_list',
            'vehicle-events': 'report_generate_vehicle_event_report',
            event: {
                add: 'events_add',
                update: 'events_update',
                view: 'events_view',
            },
            reports: 'generate_reports',
            maintenance: {
                index: 'maintenance_list',
                add: 'maintenance_add',
                view: 'maintenance_update',
                update: 'maintenance_update',
                close: 'maintenance_close'
            },
            'maintenance-work-jobs': 'maintenance_work_jobs_list',
            'maintenance-work-job': {
                add: 'maintenance_work_jobs_add',
                view: 'maintenance_work_jobs_view',
                update: 'maintenance_work_jobs_update'
            },
            tracker: {
                index: 'tracker_list'
            },
            'fuel-fillings': 'fuel_filling_list',
            'fuel-filling': {
                add: 'fuel_filling_add',
                view: 'fuel_filling_view'
            },
            'general-reports': 'generate_reports',
            'general-report': {
                consolidated: 'general_report_generate_consolidated_report',
                'cumulative-consolidated-corporate': 'general_report_generate_cumulative_consolidated_corporate_report',
                nr: 'generate_nr_report',
                poi: 'general_report_generate_poi_visit_report',
                'stop-over': 'general_report_generate_stop_over',
                'over-speed': 'general_report_generate_over_speed',
                'distance-with-fuel': 'report_generate_distance_with_fuel',
                'excess-idle': 'general_report_generate_excess_idle',
                'fuel-vehicle': 'report_generate_fuel_vehicle',
                'continuous-driving': 'general_report_continuous_driving',
                'poi-stay-in':'general_report_generate_poi_stay_in_report',
                'movement':'general_report_generate_movement_report'
            },
            'vehicle-live-status': 'vehicle_live_details'
        };

    static GetPermissions(key) {
        return PermissionHelperModule.DecodeData(key, PermissionsData.permission);
    }
}
